/* src/app/core/pages/change-password/change-password.component.scss */
.main-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: whitesmoke;
}
.main-container .left-container {
  flex: 4;
  height: 100%;
}
.main-container .right-container {
  flex: 2;
  height: 100%;
  max-width: 30rem;
  min-width: 20rem;
}
/*# sourceMappingURL=change-password.component.css.map */
